
import userApi from "../../../api/UserApi"

// export const myAction = async ({ commit }) => {
// }

export const createUser = async ( user) => {

    const {  usuario,
    nombre,
    nit,
    direccion,
    contacto,
    correo,
    telefono,
    estado,
    tipo,
    password } = user 


    try {
        const { data } = await userApi.post('add-user',{ usuario,
            nombre,
            nit,
            direccion,
            contacto,
            correo,
            telefono,
            estado,
            tipo,
            password})

            console.log( data)

            // TODO : Mutation

            return { ok: true }


    } catch (error) {
        console.log( error)
        return { ok: false , message: error.response}
    }


}